import { useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useAppContext } from './state';
import { ActionType } from './state/action-type.enum';
import PopUp from './components/kit/pop-up/PopUp';
import Enrollment from './pages/enrollment/EnrollmentPage';
import HomePage from './pages/home/HomePage';
import { AppRoutes } from 'src/types/app-routes.enum';
import DataPage from './pages/data/DataPage';
import VyduraReminderPage from './pages/vydura-reminder/VyduraReminderPage';
import NotFoundPage from './pages/not-found/NotFoundPage';
import DoctorAppointmentPage from './pages/doctor-appointment/DoctorAppointmentPage';
import MigraineAttackPage from './pages/migraine-attack/MigraineAttackPage';
import VyduraIntakePage from './pages/vydura-intake/VyduraIntakePage';
import CalendarPage from './pages/calendar/CalendarPage';
import styles from './App.module.css';

const App = () => {
  const {
    state: { isPopUpOpened },
    dispatch,
  } = useAppContext();
  const handlePopUpClose = useCallback(
    () => dispatch({ type: ActionType.POP_UP_CLOSE, payload: {} }),
    [dispatch]
  );

  return (
    <Router>
      <div className={styles.app}>
        <Routes>
          <Route path={AppRoutes.Enrollment} element={<Enrollment />} />
          <Route path={AppRoutes.Home} element={<HomePage />} />
          <Route path={AppRoutes.Reminder} element={<VyduraReminderPage />} />
          <Route
            path={AppRoutes.DoctorAppointment}
            element={<DoctorAppointmentPage />}
          />
          <Route path={AppRoutes.Data} element={<DataPage />} />
          <Route
            path={AppRoutes.MigraineAttack}
            element={<MigraineAttackPage />}
          />
          <Route path={AppRoutes.VyduraIntake} element={<VyduraIntakePage />} />
          <Route path={AppRoutes.Calendar} element={<CalendarPage />} />
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
        <PopUp isOpened={isPopUpOpened} onClose={handlePopUpClose} />
      </div>
    </Router>
  );
};

export default App;
